import axios from 'axios'
import { buildAirPriceGuideRequest } from './buildAirPriceGuideRequest'
import { getGraphURL } from '../../../utils/getServiceUrl'
import { APOLLO_CLIENT_NAME } from '@mfs/client/common/constants/constants'

export function getFlexDates({ request, onlyViewers = false, tripType }) {
  let data = buildAirPriceGuideRequest({ request, tripType, onlyViewers })
  const url = getGraphURL({ operationName: data?.operationName })

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      data,
      headers: {
        'apollographql-client-name': APOLLO_CLIENT_NAME,
        'apollographql-client-version': globalThis.PCLN_BOOTSTRAP_DATA?.appVersion || 'development',
      },
    })
      .then((searchResult) => {
        // Air Price Guide
        if (onlyViewers & searchResult?.data?.data?.airPriceGuide?.viewers) {
          resolve(searchResult.data.data.airPriceGuide.viewers)
        } else if (searchResult?.data?.data?.airPriceGuide?.records?.length >= 0) {
          resolve(searchResult.data.data.airPriceGuide.records)
        } else {
          reject('No valid response received from elastic')
        }

        // eslint-disable-next-line sonarjs/no-redundant-jump
        return
      })
      .catch((error) => {
        reject(error)
      })
  })
}
